import GiftValuePanel from './GiftValuePanel';

export default GiftValuePanel;
